import $http from "../../axios";
import { Notification } from "element-ui";

const apiEndpoint = "/api/reservation-product";

export async function fetchReservationProducts({ commit, state }, params) {
    try {
        const response = await $http.get(apiEndpoint, {
            params
        });
        commit("setReservationProducts", response.data);
    } catch (error) {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
        commit("setError", error.message);
    }
}

export async function fetchReservationProduct({ commit }, id) {
    try {
        const response = await $http.get(`${apiEndpoint}/${id}`);
        commit("setReservationProduct", response.data);
    } catch (error) {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
        commit("setError", error.message);
    }
}

export async function createReservationProduct({ commit }, reservationProduct) {
    try {
        const response = await $http.post(apiEndpoint, reservationProduct);
        commit("setReservationProduct", null);
        Notification.success({
            title: "Exito!",
            message: "Reservado con Exito!",
            type: "success",
            duration: 2000,
            customClass: "notification-box"
        });
    } catch (error) {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
        commit("setError", error.message);
    }
}

export async function updateReservationProduct({ commit }, reservationProduct) {
    try {
        const response = await $http.put(
            `${apiEndpoint}/${reservationProduct.id}`,
            reservationProduct
        );
        Notification.success({
            title: "Exito!",
            message: "Actualizado con Exito!",
            type: "success",
            duration: 2000,
            customClass: "notification-box"
        });
    } catch (error) {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
        commit("setError", error.message);
    }
}

export async function deleteReservationProduct({ commit }, id) {
    try {
        await $http.delete(`${apiEndpoint}/${id}`);
        commit("setReservationProduct", null);
        Notification.success({
            title: "Exito!",
            message: "Reserva eliminada con Exito!",
            type: "success",
            duration: 2000,
            customClass: "notification-box"
        });
    } catch (error) {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
        commit("setError", error.message);
    }
}

export async function fetchContacts({ commit }, filter) {
    const params = {
        filter,
        is_customer: true,
        paginate: false
    };

    await $http
        .get("/api/terceros-lite", { params })
        .then(async response => {
            commit("setContacts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function searchProducts({ commit }, filter) {
    const params = {
        filter,
        paginate: false,
        branchoffice_id: localStorage.selected_branchoffice,
        branchoffice_warehouse_id: localStorage.selected_branchoffice_warehouse
    };

    await $http.get("/api/lista-productos", { params }).then(response => {
        commit("setProducts", response.data.data.data);
    });
}




// WEBPACK FOOTER //
// ./src/modules/reservationProduct/actions.js